export default [
  {
    label: 'GMT-12:00 Eniwetok, Kwajalein',
    index: 0,
  },
  {
    label: 'GMT-11:00 Midway Island, Samoa',
    index: 1,
  },
  {
    label: 'GMT-10:00 Hawaii',
    index: 2,
  },
  {
    label: 'GMT-9:30 Taiohae',
    index: 3,
  },
  {
    label: 'GMT-9:00 Alaska',
    index: 4,
  },
  {
    label: 'GMT-8:00 Pacific Time US, Canada',
    index: 5,
  },
  {
    label: 'GMT-7:00 Mountain Time US, Canada',
    index: 6,
  },
  {
    label: 'GMT-6:00 Central Time US, Canada, Mexico City',
    index: 7,
  },
  {
    label: 'GMT-5:00 Eastern Time US, Canada, Bogota, Lima',
    index: 8,
  },
  {
    label: 'GMT-4:30 Caracas',
    index: 9,
  },
  {
    label: 'GMT-4:00 Atlantic Time Canada, Caracas, La Paz',
    index: 10,
  },
  {
    label: 'GMT-3:30 Newfoundland',
    index: 11,
  },
  {
    label: 'GMT-3:00 Brazil, Buenos Aires, Georgetown',
    index: 12,
  },
  {
    label: 'GMT-2:00 Mid-Atlantic',
    index: 13,
  },
  {
    label: 'GMT-1:00 Azores, Cape Verde Islands',
    index: 14,
  },
  {
    label: 'GMT+0:00 Western Europe Time, London, Lisbon, Casablanca',
    index: 15,
  },
  {
    label: 'GMT+1:00 Brussels, Copenhagen, Madrid, Paris',
    index: 16
  },
  {
    label: 'GMT+2:00 Kaliningrad, South Africa',
    index: 17
  },
  {
    label: 'GMT+3:00 Baghdad, Riyadh, Moscow, St. Petersburg',
    index: 18
  },
  {
    label: 'GMT+3:30 Tehran',
    index: 19
  },
  {
    label: 'GMT+4:00 Abu Dhabi, Muscat, Baku, Tbilisi',
    index: 20
  },
  {
    label: 'GMT+4:30 Kabul',
    index: 21
  },
  {
    label: 'GMT+5:00 Ekaterinburg, Islamabad, Karachi, Tashkent',
    index: 22
  },
  {
    label: 'GMT+5:30 Bombay, Calcutta, Madras, New Delhi',
    index: 23
  },
  {
    label: 'GMT+5:45 Kathmandu, Pokhara',
    index: 24
  },
  {
    label: 'GMT+6:00 Almaty, Dhaka, Colombo',
    index: 25
  },
  {
    label: 'GMT+6:30 Yangon, Mandalay',
    index: 26
  },
  {
    label: 'GMT+7:00 Bangkok, Hanoi, Jakarta',
    index: 27
  },
  {
    label: 'GMT+8:00 Beijing, Perth, Singapore, Hong Kong',
    index: 28
  },
  {
    label: 'GMT+8:45 Eucla',
    index: 29
  },
  {
    label: 'GMT+9:00 Tokyo, Seoul, Osaka, Sapporo, Yakutsk',
    index: 30
  },
  {
    label: 'GMT+9:30 Adelaide, Darwin',
    index: 31
  },
  {
    label: 'GMT+10:00 Eastern Australia, Guam, Vladivostok',
    index: 32
  },
  {
    label: 'GMT+10:30 Lord Howe Island',
    index: 33
  },
  {
    label: 'GMT+11:00 Magadan, Solomon Islands, New Caledonia',
    index: 34
  },
  {
    label: 'GMT+11:30 Norfolk Island',
    index: 35
  },
  {
    label: 'GMT+12:00 Auckland, Wellington, Fiji, Kamchatka',
    index: 36
  },
  {
    label: 'GMT+12:45 Chatham Islands',
    index: 37
  },
  {
    label: 'GMT+13:00 Apia, Nukualofa',
    index: 38
  },
  {
    label: 'GMT+14:00 Line Islands, Tokelau',
    index: 39
  }
]
